import { IBudgetProposals, IMergeTags } from '@opengov/stories-shared/types';
import React, { useState } from 'react';
import { IStoryViewMessages } from '../../../../../types';
import { ConfirmationModal } from '../../../../common/components/ConfirmationModal';
import { useRemoveProposalsInStory } from '../../hooks';

interface IRemoveProposalConfirmationModalProps {
  messages: IStoryViewMessages;
  isRemoveLastProposal: boolean;
  storyId: string;
  entityId: number;
  proposalId: IBudgetProposals['proposalId'];
  setProposalToRemove(proposal: IBudgetProposals | null): void;
  onProposalRemoved(params: { mergeTags: IMergeTags }): Promise<void>;
}

export const RemoveProposalConfirmationModal = ({
  messages,
  storyId,
  entityId,
  proposalId,
  isRemoveLastProposal = false,
  setProposalToRemove,
  onProposalRemoved
}: IRemoveProposalConfirmationModalProps) => {
  const [isDeletingProposal, setIsDeletingProposal] = useState<boolean>(false);
  const { mutate: doRemoveProposal } = useRemoveProposalsInStory();

  const handleProposalRemove = () => {
    setIsDeletingProposal(true);
    doRemoveProposal(
      { storyId, proposalId, entityId },
      {
        onSuccess: (data) => void onProposalRemoved({ mergeTags: data.mergeTags as IMergeTags }),
        onSettled: () => {
          setIsDeletingProposal(false);
          setProposalToRemove(null);
        }
      }
    );
  };

  return (
    <ConfirmationModal
      title={messages.removeProposal}
      description={isRemoveLastProposal ? messages.removeLastProposalDesc : messages.removeProposalDesc}
      dataTest="delete-proposal-confirmation-modal"
      confirmationRequired={true}
      actionPending={isDeletingProposal}
      confirmationText={messages.remove}
      confirmationButtonVariant="destructive"
      onCancel={() => !isDeletingProposal && setProposalToRemove(null)}
      onProceed={handleProposalRemove}
    />
  );
};
